(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    const mobileGroupQuery = window.matchMedia('(max-width: 749px)');
  const resizeGroupSelector = '.group-block--zoom-hover-resize';
  const mobileActiveClass = 'group-block--mobile-hover-active';

  function startMobileGroupHover(group) {
    if (!mobileGroupQuery.matches || group.classList.contains(mobileActiveClass)) return;
    if (!group.style.getPropertyValue('--group-mobile-resize-base')) {
      group.style.setProperty('--group-mobile-resize-base', `${group.getBoundingClientRect().height}px`);
    }
    // Resolve the numeric starting height before transitioning from a fit-content layout.
    group.getBoundingClientRect();
    group.classList.add(mobileActiveClass);
  }

  function endMobileGroupHover(group) {
    group.classList.remove(mobileActiveClass);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      group.style.removeProperty('--group-mobile-resize-base');
    }
  }

  document.addEventListener('pointerover', (event) => {
    const group = event.target.closest(resizeGroupSelector);
    if (group && !group.contains(event.relatedTarget)) startMobileGroupHover(group);
  });

  document.addEventListener('pointerout', (event) => {
    const group = event.target.closest(resizeGroupSelector);
    if (group && !group.contains(event.relatedTarget) && !group.matches(':focus-within')) {
      endMobileGroupHover(group);
    }
  });

  document.addEventListener('focusin', (event) => {
    const group = event.target.closest(resizeGroupSelector);
    if (group) startMobileGroupHover(group);
  });

  document.addEventListener('focusout', (event) => {
    const group = event.target.closest(resizeGroupSelector);
    if (group && !group.contains(event.relatedTarget) && !group.matches(':hover')) endMobileGroupHover(group);
  });

  document.addEventListener('transitionend', (event) => {
    const group = event.target;
    if (event.propertyName === 'height' && group.matches(resizeGroupSelector) && !group.classList.contains(mobileActiveClass)) {
      group.style.removeProperty('--group-mobile-resize-base');
    }
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll(resizeGroupSelector).forEach((group) => {
      group.classList.remove(mobileActiveClass);
      group.style.removeProperty('--group-mobile-resize-base');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
